import { Reveal } from "./Reveal";

export const ChapterHeading = ({ number, title, subtitle, color = "#D81B60", center = false }) => {
  if (center) {
    return (
      <div className="relative flex flex-col items-center text-center mb-8 sm:mb-10">
        <div className="absolute -top-6 w-40 h-40 rounded-full blur-3xl pointer-events-none" style={{ backgroundColor: `${color}18` }} />
        <Reveal delay={0}>
          <span className="relative font-extrabold text-4xl sm:text-6xl leading-none select-none block" style={{ color: `${color}30` }}>
            {number}
          </span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="relative mt-2 font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-tight text-[#1A1A1A]">{title}</h2>
          {subtitle && <p className="relative mt-3 text-base sm:text-lg text-gray-500 max-w-xl mx-auto">{subtitle}</p>}
          <span className="relative block w-10 h-1 rounded-full mx-auto mt-5" style={{ backgroundColor: color }} />
        </Reveal>
      </div>
    );
  }
  return (
    <div className="relative flex items-start gap-4 sm:gap-8 mb-8 sm:mb-10">
      <div className="absolute -top-6 -left-4 w-32 h-32 rounded-full blur-3xl pointer-events-none" style={{ backgroundColor: `${color}18` }} />
      <Reveal delay={0}>
        <span className="relative font-extrabold text-4xl sm:text-6xl leading-none select-none" style={{ color: `${color}30` }}>
          {number}
        </span>
      </Reveal>
      <Reveal delay={0.1} className="relative pt-1 sm:pt-3">
        <h2 className="font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-tight text-[#1A1A1A]">{title}</h2>
        {subtitle && <p className="mt-3 text-base sm:text-lg text-gray-500 max-w-xl">{subtitle}</p>}
        <span className="block w-10 h-1 rounded-full mt-5" style={{ backgroundColor: color }} />
      </Reveal>
    </div>
  );
};
